var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.wrapperClass},[_c('calendar-header',{attrs:{"disable":_vm.disabledDays}}),_c('calendar-body',{attrs:{"events":_vm.calendarEvents,"disable":_vm.disabledDays,"highlight":_vm.highlightedDays,"display-show-more-count":_vm.displayShowMoreCount}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }